import { ILegalEntity } from '@common/interfaces/legalEntity'
import { combineReducers } from 'redux'
import { loadingArrayReducer } from '../../helpers/helpers'
import { createLoadingDataReducer } from '../../helpers/redux'
import { IAction } from '../apiMiddleware'
import * as actions from './actions'

export default combineReducers({
  loadingArray: loadingArrayReducer([actions.prefix]),
  list(state: ILegalEntity[] = [], action: IAction): ILegalEntity[] {
    switch (action.type) {
      case actions.CREATE_SUCCESS:
        return [...state, action.data as ILegalEntity]
      case actions.DELETE_SUCCESS:
        return state.filter(({ id }) => (action.data as ILegalEntity).id !== id)
      case actions.UPDATE_SUCCESS:
      case actions.WAIVE_SUCCESS:
      case actions.WAIVE_DOCUMENT_SUCCESS:
      case actions.UNWAIVE_DOCUMENT_SUCCESS: {
        const updated = action.data as ILegalEntity
        return state.map((entity) =>
          entity.id === updated.id ? { ...entity, ...updated } : entity,
        )
      }
      case actions.LIST_SUCCESS:
        return (action.data ?? []) as ILegalEntity[]
      default:
        return state
    }
  },
  data: createLoadingDataReducer(
    [actions.LIST_REQUEST],
    [
      actions.CREATE_REQUEST,
      actions.UPDATE_REQUEST,
      actions.DELETE_REQUEST,
      actions.WAIVE_REQUEST,
      actions.WAIVE_DOCUMENT_REQUEST,
      actions.UNWAIVE_DOCUMENT_REQUEST,
    ],
    true,
  ),
})
